module.exports = __webpack_public_path__ + "static/img/logo_dt.b4e9035b.png";